import React from "react";
import no_data from "../../assets/icons/no_records.png";

const NodataComponent = ({
  img,
  title,
  msg,
  noMsg,
  module,
  noBtns,
  primaryText,
  noSecBtn,
  onPrimaryClick,
  onSecondaryClick,
  noPrimaryBtn,
  secondaryText,
  hasWriteAccess,
}) => {
  return (
    <div className="no-data d-flex-center flex-col mt1">
      <img
        src={img ?? no_data}
        alt=""
        style={{
          width: 120,
        }}
      />
      {title && <h3 className="text-center mt1">{title}</h3>}
      {!noMsg && (
        <p className="text-center mt1 no-records">
          {msg ? msg : "No records found"}
        </p>
      )}
      {noBtns ? null : (
        <div className="d-flex gap2">
          {!noPrimaryBtn && (
            <button
              disabled={!hasWriteAccess}
              className="primary-btn"
              onClick={onPrimaryClick}
            >
              {primaryText || `+ Add New ${module}`}
            </button>
          )}
          {!noSecBtn && (
            <button
              disabled={!hasWriteAccess}
              className="secondary-btn"
              onClick={onSecondaryClick}
            >
              {secondaryText}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default NodataComponent;
